const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
const favicon = document.querySelector('link[rel="shortcut icon"]');
console.log(favicon)
if (favicon) {
    const lightIcoUrl = favicon.getAttribute('data-light');
    const darkIcoUrl = favicon.getAttribute('data-dark');
    handleDarkmode(darkModeMediaQuery);
    function handleDarkmode(e){
        const darkModeOn = e.matches; // true if dark mode is enabled
        if(darkModeOn && darkIcoUrl){
            favicon.href = darkIcoUrl;
        } else {
            favicon.href = lightIcoUrl;
        }
        return;
    }

    darkModeMediaQuery.addListener(handleDarkmode); 
}
